export default __webpack_public_path__ + "i18n/languages.b3b8e46.json";